// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dataspace-ui-scale: 0.7;
  --dataspace-viewport-height: 100vh;
  --dataspace-scaled-vw: calc(100vw / var(--dataspace-ui-scale));
  --dataspace-scaled-vh: calc(var(--dataspace-viewport-height) / var(--dataspace-ui-scale));
  --dataspace-scrollbar-size: 11px;
  --dataspace-scrollbar-track: #e9eef5;
  --dataspace-scrollbar-thumb: #8fa0b6;
  --dataspace-scrollbar-thumb-hover: #526983;
}

@supports (height: 100dvh) {
  :root {
    --dataspace-viewport-height: 100dvh;
  }
}

html.browser-safari {
  --dataspace-ui-scale: 1;
  --dataspace-scaled-vw: 100vw;
  --dataspace-scaled-vh: var(--dataspace-viewport-height);
}

html {
  width: 100%;
  height: var(--dataspace-viewport-height);
  min-width: 100%;
  min-height: var(--dataspace-viewport-height);
  overflow: hidden;
  background: #f8fafc;
}

body {
  margin: 0;
  width: var(--dataspace-scaled-vw);
  height: var(--dataspace-scaled-vh);
  min-height: var(--dataspace-scaled-vh);
  overflow: hidden;
  zoom: var(--dataspace-ui-scale);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html.browser-safari body {
  zoom: 1;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--dataspace-scrollbar-thumb) var(--dataspace-scrollbar-track);
}

*::-webkit-scrollbar {
  width: var(--dataspace-scrollbar-size);
  height: var(--dataspace-scrollbar-size);
}

*::-webkit-scrollbar-track {
  background: var(--dataspace-scrollbar-track);
  border-radius: 999px;
}

*::-webkit-scrollbar-thumb {
  min-height: 40px;
  border: 3px solid var(--dataspace-scrollbar-track);
  border-radius: 999px;
  background: var(--dataspace-scrollbar-thumb);
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--dataspace-scrollbar-thumb-hover);
}

#root {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

body.dataspace-shell-active #root {
  overflow: hidden;
}

html.city-tours-route,
html.catalog-route,
html.health-questionnaire-route {
  height: var(--dataspace-viewport-height);
  min-height: 0;
  overflow: hidden;
}

body.city-tours-route,
body.catalog-route,
body.health-questionnaire-route {
  height: var(--dataspace-scaled-vh);
  min-height: 0;
  overflow: hidden;
}

body.city-tours-route #root,
body.catalog-route #root,
body.health-questionnaire-route #root {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,8DAA8D;EAC9D,yFAAyF;EACzF,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;EAC/B;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,wCAAwC;EACxC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[":root {\n  --dataspace-ui-scale: 0.7;\n  --dataspace-viewport-height: 100vh;\n  --dataspace-scaled-vw: calc(100vw / var(--dataspace-ui-scale));\n  --dataspace-scaled-vh: calc(var(--dataspace-viewport-height) / var(--dataspace-ui-scale));\n  --dataspace-scrollbar-size: 11px;\n  --dataspace-scrollbar-track: #e9eef5;\n  --dataspace-scrollbar-thumb: #8fa0b6;\n  --dataspace-scrollbar-thumb-hover: #526983;\n}\n\n@supports (height: 100dvh) {\n  :root {\n    --dataspace-viewport-height: 100dvh;\n  }\n}\n\nhtml.browser-safari {\n  --dataspace-ui-scale: 1;\n  --dataspace-scaled-vw: 100vw;\n  --dataspace-scaled-vh: var(--dataspace-viewport-height);\n}\n\nhtml {\n  width: 100%;\n  height: var(--dataspace-viewport-height);\n  min-width: 100%;\n  min-height: var(--dataspace-viewport-height);\n  overflow: hidden;\n  background: #f8fafc;\n}\n\nbody {\n  margin: 0;\n  width: var(--dataspace-scaled-vw);\n  height: var(--dataspace-scaled-vh);\n  min-height: var(--dataspace-scaled-vh);\n  overflow: hidden;\n  zoom: var(--dataspace-ui-scale);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml.browser-safari body {\n  zoom: 1;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--dataspace-scrollbar-thumb) var(--dataspace-scrollbar-track);\n}\n\n*::-webkit-scrollbar {\n  width: var(--dataspace-scrollbar-size);\n  height: var(--dataspace-scrollbar-size);\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--dataspace-scrollbar-track);\n  border-radius: 999px;\n}\n\n*::-webkit-scrollbar-thumb {\n  min-height: 40px;\n  border: 3px solid var(--dataspace-scrollbar-track);\n  border-radius: 999px;\n  background: var(--dataspace-scrollbar-thumb);\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--dataspace-scrollbar-thumb-hover);\n}\n\n#root {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\nbody.dataspace-shell-active #root {\n  overflow: hidden;\n}\n\nhtml.city-tours-route,\nhtml.catalog-route,\nhtml.health-questionnaire-route {\n  height: var(--dataspace-viewport-height);\n  min-height: 0;\n  overflow: hidden;\n}\n\nbody.city-tours-route,\nbody.catalog-route,\nbody.health-questionnaire-route {\n  height: var(--dataspace-scaled-vh);\n  min-height: 0;\n  overflow: hidden;\n}\n\nbody.city-tours-route #root,\nbody.catalog-route #root,\nbody.health-questionnaire-route #root {\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
